import styled, { css } from 'styled-components'

const StyledTitle = styled.h1`
font-size: 1.2em;
font-weight: normal;
${props => props.capital && css`
text-transform: capitalize;
`}
${props => props.bold && css`
font-weight: bold;
`}
`

export const Title = props => {
    return <StyledTitle {...props}>{props.children}</StyledTitle>
}